import React from "react"
import { Container } from "@components"
import { Box, Flex } from "rebass"
import faqs from "@constants/faqs.js"
import { InternalLink } from "@fragments"

const Content = () => (
  <Container>
    <Box mt={[32, 62]}>
      <Flex flexDirection="column">
        <p>
          Amazon DynamoDB is a managed NoSQL database for key-value and document data. These answers cover its data model, queries, consistency, transactions, costs and operational limits. Choose a question below for the explanation and relevant examples.
        </p>
        <ul>
          {faqs
            .map((faq, index) => (
              <li key={`faq-${index + 1}`} style={{ marginBottom: 0 }} className="list-item-with-spacing">
                <InternalLink to={`/dynamodb-faq/${faq.slug}/`}>
                  {faq.question}
                </InternalLink>
              </li>
            ))}
        </ul>
      </Flex>
    </Box>
  </Container>
)

export default Content
